import React, { useContext, useEffect } from 'react'
import PageLoading from '../components/atoms/PageLoading/PageLoading'
import Content from '../components/hoc/LayOut/Content'
import { AuthContext } from '../context/AuthContext'
import useLoginHook from '../hooks/LoginHook'

const Home = () => {
  const { isAuthenticating } = useLoginHook()
  const authContext = useContext(AuthContext)
  const { updateState } = authContext
  useEffect(() => {
    updateState({ isFormChanged: false })
  }, [])
  return (
    <Content>
      <PageLoading loading={isAuthenticating} />
    </Content>
  )
}

export default Home
